module.exports = __webpack_public_path__ + "img/icons-list-2.92f8f7f5.png";